  function customSortProducts() {
    const productGrid = document.querySelector('.collection-products');
    if (!productGrid) return;
    
    const products = Array.from(productGrid.children);

    const platinumProducts = products.filter(p => p.dataset.customPlatinum === "true");

    const nonPlatinumProducts = products.filter(p => p.dataset.customPlatinum !== "true");
    
    for (let i = platinumProducts.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [platinumProducts[i], platinumProducts[j]] = [platinumProducts[j], platinumProducts[i]];
    }
    
    for (let i = nonPlatinumProducts.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [nonPlatinumProducts[i], nonPlatinumProducts[j]] = [nonPlatinumProducts[j], nonPlatinumProducts[i]];
    }
    
    const sortedProducts = [...platinumProducts, ...nonPlatinumProducts];
    productGrid.innerHTML = '';
    sortedProducts.forEach(product => productGrid.appendChild(product));
  }

customSortProducts()